/* ═══════════════════════════════════════════════════════════
   FICTION KEYWORDS — comprehensive tag list for book tagging
   Covers all fiction genres, tropes, themes, settings, tones
   Used by the author book form for smart-search keyword selection
═══════════════════════════════════════════════════════════ */

export const FICTION_KEYWORDS = [
  // ─── GENRES & SUBGENRES ───────────────────────────────
  { category: 'Genre', keywords: [
    // Fantasy
    'Fantasy', 'High Fantasy', 'Epic Fantasy', 'Dark Fantasy', 'Urban Fantasy',
    'Contemporary Fantasy', 'Gaslamp Fantasy', 'Grimdark', 'Heroic Fantasy',
    'Sword & Sorcery', 'Fairy Tale Retelling', 'Mythic Fantasy', 'Portal Fantasy',
    'Romantasy', 'Cosy Fantasy', 'Low Fantasy', 'Military Fantasy',
    'Fantasy of Manners', 'Progression Fantasy', 'LitRPG',
    // Science Fiction
    'Science Fiction', 'Space Opera', 'Hard Sci-Fi', 'Soft Sci-Fi', 'Cyberpunk',
    'Solarpunk', 'Biopunk', 'Steampunk', 'Dieselpunk', 'Afrofuturism',
    'Military Sci-Fi', 'First Contact', 'Post-Apocalyptic', 'Dystopian',
    'Utopian', 'Time Travel', 'Alternate History', 'Climate Fiction',
    'Generation Ship', 'AI / Artificial Intelligence', 'Space Colonisation',
    // Romance
    'Romance', 'Contemporary Romance', 'Historical Romance', 'Paranormal Romance',
    'Romantic Suspense', 'Romantic Comedy', 'Rom-Com', 'Dark Romance',
    'Erotic Romance', 'Clean Romance', 'Sweet Romance', 'Inspirational Romance',
    'Sports Romance', 'Military Romance', 'Billionaire Romance', 'Cowboy Romance',
    'Mafia Romance', 'MC / Biker Romance', 'Small Town Romance',
    'Holiday Romance', 'Workplace Romance', 'Second Chance Romance',
    'Marriage of Convenience', 'Fake Relationship', 'Enemies to Lovers',
    'Friends to Lovers', 'Age Gap Romance', 'Forbidden Romance',
    'Reverse Harem', 'Why Choose',
    // Mystery & Thriller
    'Mystery', 'Cosy Mystery', 'Police Procedural', 'Private Investigator',
    'Amateur Sleuth', 'Whodunit', 'Locked Room Mystery', 'Cold Case',
    'Thriller', 'Psychological Thriller', 'Legal Thriller', 'Medical Thriller',
    'Political Thriller', 'Techno-Thriller', 'Spy / Espionage', 'Heist',
    'Domestic Thriller', 'Crime Fiction', 'Noir', 'Hardboiled',
    // Horror
    'Horror', 'Gothic Horror', 'Cosmic Horror', 'Lovecraftian', 'Body Horror',
    'Psychological Horror', 'Slasher', 'Haunted House', 'Zombie',
    'Folk Horror', 'Southern Gothic', 'Quiet Horror', 'Survival Horror',
    // Historical
    'Historical Fiction', 'Ancient World', 'Medieval', 'Tudor',
    'Georgian', 'Regency', 'Victorian', 'Edwardian', 'World War I',
    'World War II', 'Post-War', '1960s / 1970s', 'Viking',
    'Ancient Rome', 'Ancient Greece', 'Ancient Egypt', 'Feudal Japan',
    'Renaissance', 'American Civil War', 'American Revolution',
    'Wild West / Frontier', 'Napoleonic',
    // Literary & General
    'Literary Fiction', 'Book Club Fiction', 'Upmarket Fiction',
    'Family Saga', 'Coming-of-Age', 'Bildungsroman', 'Domestic Fiction',
    'Women\'s Fiction', 'Lad Lit', 'Chick Lit',
    'Satire', 'Absurdist', 'Magical Realism', 'Surrealist',
    'Experimental', 'Epistolary', 'Metafiction', 'Autofiction',
    'Flash Fiction', 'Short Stories', 'Anthology', 'Novella',
    // Adventure & Action
    'Adventure', 'Action', 'Survival', 'Treasure Hunt', 'Quest',
    'Pirate', 'Seafaring', 'Exploration', 'Expedition',
    // Other genres
    'Westerns', 'War Fiction', 'Biographical Fiction', 'Speculative Fiction',
    'Slipstream', 'New Weird', 'Cli-Fi', 'Hopepunk', 'Noblebright',
    'Graphic Novel', 'Manga', 'Light Novel', 'Web Serial',
    'Young Adult', 'New Adult', 'Middle Grade', 'Children\'s Fiction',
    'Religious / Inspirational', 'Amish Fiction', 'Christian Fiction',
    'Myths & Legends', 'Folklore',
  ]},

  // ─── TROPES ───────────────────────────────────────────
  { category: 'Tropes', keywords: [
    'Enemies to Lovers', 'Friends to Lovers', 'Slow Burn', 'Insta-Love',
    'Forced Proximity', 'Only One Bed', 'Fake Relationship', 'Fake Dating',
    'Arranged Marriage', 'Marriage of Convenience', 'Second Chances',
    'Forbidden Love', 'Secret Relationship', 'Love Triangle', 'Love Square',
    'Grumpy / Sunshine', 'Ice Queen', 'Brooding Hero', 'Golden Retriever Energy',
    'Opposites Attract', 'Matched by Fate', 'Fated Mates', 'Soul Mates',
    'Boss / Employee', 'Student / Teacher', 'Age Gap', 'Class Difference',
    'Height Difference', 'Multicultural', 'Secret Identity',
    'Best Friend\'s Sibling', 'Sibling\'s Best Friend', 'Parent\'s Best Friend',
    'Best Friend\'s Parent', 'Step Siblings',
    'Hurt / Comfort', 'Good Grovel', 'Grand Gesture',
    'Friends with Benefits', 'One Night Stand', 'Pregnancy',
    'Secret Baby', 'Single Parent', 'Amnesia',
    'Chosen One', 'Reluctant Hero', 'Anti-Hero', 'Morally Grey',
    'Found Family', 'Fish Out of Water', 'Road Trip',
    'Rags to Riches', 'Riches to Rags', 'Underdog',
    'Rivals to Lovers', 'Bodyguard Romance', 'Protector',
    'Who Did It?', 'Red Herring', 'Unreliable Narrator',
    'Mistaken Identity', 'Disguise', 'Hidden Royalty',
    'Dark Secret', 'Revenge Plot', 'Betrayal',
    'Redemption Arc', 'Sacrifice', 'Resurrection',
    'Prophecy', 'Curse', 'Quest', 'Tournament',
    'Trapped Together', 'Snowed In', 'Stranded',
    'Caretaking', 'Damaged Hero', 'Healing Love',
    'Touch Her and Die', 'Possessive Hero', 'Protective Hero',
    'Cinnamon Roll Hero', 'Sunshine Heroine', 'Kickass Heroine',
    'Bookish Heroine', 'Villain Romance', 'Monster Romance',
    'Alien Romance', 'Vampire Romance', 'Werewolf Romance',
    'Shifter Romance', 'Dragon Romance', 'Fae Romance',
    'Witch / Warlock', 'Necromancer', 'Pirate Romance',
    'Viking Romance', 'Highlander Romance', 'Regency Romance',
    'Cowboy Romance', 'Rock Star Romance', 'Athlete Romance',
    'Celebrity Romance', 'Royal Romance',
  ]},

  // ─── THEMES ───────────────────────────────────────────
  { category: 'Themes', keywords: [
    'Identity', 'Self-Discovery', 'Coming-of-Age', 'Growing Up',
    'Grief & Loss', 'Healing', 'Recovery', 'Redemption',
    'Forgiveness', 'Revenge', 'Justice', 'Injustice',
    'Love & Relationships', 'Friendship', 'Family', 'Motherhood',
    'Fatherhood', 'Sibling Bonds', 'Found Family', 'Belonging',
    'Loneliness', 'Isolation', 'Community', 'Loyalty',
    'Betrayal', 'Trust', 'Power', 'Corruption',
    'Freedom', 'Captivity', 'Survival', 'Sacrifice',
    'Morality', 'Good vs Evil', 'Moral Ambiguity',
    'War & Conflict', 'Peace', 'Revolution', 'Rebellion',
    'Class & Inequality', 'Racism', 'Discrimination',
    'Feminism', 'LGBTQ+ Themes', 'Queerness', 'Gender Identity',
    'Disability Representation', 'Neurodivergence', 'Mental Health',
    'Addiction & Recovery', 'Body Image', 'Eating Disorders',
    'Nature & Environment', 'Technology & Humanity', 'Faith & Doubt',
    'Destiny vs Free Will', 'Time & Memory', 'Death & Mortality',
    'Immortality', 'Legacy', 'Art & Creativity', 'Music',
    'Food & Culture', 'Immigration & Diaspora', 'Home & Homesickness',
    'Colonialism', 'Decolonisation', 'Politics',
    'Education', 'Ambition', 'Success & Failure',
  ]},

  // ─── SETTING ──────────────────────────────────────────
  { category: 'Setting', keywords: [
    'Small Town', 'Big City', 'Rural', 'Suburban', 'Village',
    'Island', 'Coastal', 'Mountain', 'Desert', 'Forest',
    'Arctic / Tundra', 'Tropical', 'Underground', 'Underwater',
    'Space', 'Space Station', 'Another Planet', 'Spaceship',
    'Fantasy World', 'Secondary World', 'Parallel Universe', 'Multiverse',
    'Dystopian Society', 'Utopian Society', 'Post-Apocalyptic Wasteland',
    'Castle / Palace', 'Manor House', 'Cottage', 'Farm / Ranch',
    'School / Academy', 'University', 'Boarding School',
    'Military Base', 'Prison', 'Hospital', 'Asylum',
    'Tavern / Inn', 'Bookshop', 'Library', 'Cafe',
    'Workplace / Office', 'Theatre', 'Circus',
    'Haunted House', 'Gothic Mansion', 'Ruins',
    'Ship / Boat', 'Train', 'Road / Highway',
    // Geography
    'British Isles', 'Scotland', 'Ireland', 'England', 'Wales',
    'France', 'Italy', 'Spain', 'Greece', 'Scandinavia',
    'Germany', 'Eastern Europe', 'Russia', 'Turkey',
    'USA', 'New York', 'Los Angeles', 'Southern USA', 'Midwest',
    'Canada', 'Australia', 'New Zealand',
    'Japan', 'China', 'Korea', 'India', 'Southeast Asia',
    'Middle East', 'North Africa', 'Sub-Saharan Africa',
    'Caribbean', 'Central America', 'South America', 'Brazil',
    'Antarctica',
  ]},

  // ─── TONE & MOOD ──────────────────────────────────────
  { category: 'Tone & Mood', keywords: [
    'Dark', 'Gritty', 'Bleak', 'Atmospheric', 'Moody',
    'Suspenseful', 'Tense', 'Creepy', 'Eerie', 'Unsettling',
    'Light-Hearted', 'Fun', 'Humorous', 'Witty', 'Sarcastic',
    'Heartwarming', 'Feel-Good', 'Cosy', 'Wholesome', 'Uplifting',
    'Emotional', 'Angsty', 'Tear-Jerker', 'Bittersweet',
    'Hopeful', 'Optimistic', 'Melancholic', 'Nostalgic',
    'Romantic', 'Steamy', 'Sensual', 'Passionate',
    'Adventurous', 'Thrilling', 'Action-Packed', 'Fast-Paced',
    'Slow-Paced', 'Contemplative', 'Philosophical', 'Introspective',
    'Whimsical', 'Dreamlike', 'Surreal', 'Lyrical', 'Poetic',
    'Raw', 'Unflinching', 'Provocative', 'Thought-Provoking',
    'Page-Turner', 'Unputdownable', 'Cinematic', 'Immersive',
  ]},

  // ─── CHARACTERS ───────────────────────────────────────
  { category: 'Characters', keywords: [
    // Heroine types
    'Strong Heroine', 'Kickass Heroine', 'Bookish Heroine', 'Shy Heroine',
    'Sassy Heroine', 'Independent Heroine', 'Take-Charge Heroine',
    'Sweet / Gentle Heroine', 'Grumpy Heroine', 'Ice Queen',
    'Warrior Heroine', 'Princess', 'Queen', 'Spy Heroine',
    'Detective Heroine', 'Scientist Heroine', 'Healer / Doctor',
    'Artist Heroine', 'Witch Heroine', 'Fae Heroine',
    // Hero types
    'Alpha Hero', 'Beta Hero', 'Cinnamon Roll Hero', 'Bad Boy',
    'Brooding Hero', 'Grumpy Hero', 'Sunshine Hero', 'Nerdy Hero',
    'Damaged Hero', 'Tortured Hero', 'Possessive Hero', 'Protective Hero',
    'Morally Grey Hero', 'Villain Hero', 'Anti-Hero', 'Reluctant Hero',
    'Warrior', 'Prince / King', 'Rogue', 'Thief',
    'CEO / Billionaire', 'Military / Soldier', 'Pirate Captain',
    'Highlander', 'Viking', 'Cowboy', 'Firefighter', 'Doctor',
    'Professor', 'Rock Star', 'Athlete',
    // Character attributes
    'Non-Human MC', 'Vampire MC', 'Werewolf MC', 'Fae MC', 'Dragon MC',
    'Demon MC', 'Angel MC', 'Orc MC', 'Elf MC', 'Shifter MC',
    'Disabled MC', 'Neurodivergent MC', 'Autistic MC', 'ADHD MC',
    'Deaf MC', 'Blind MC', 'Chronic Illness MC',
    'BIPOC MC', 'Trans MC', 'Non-Binary MC', 'Bisexual MC',
    'Gay MC', 'Lesbian MC', 'Asexual MC',
    'Diverse Cast', 'Ensemble Cast', 'Dual POV', 'Multiple POV',
    'First Person', 'Third Person', 'Second Person', 'Omniscient',
    'Unreliable Narrator',
  ]},

  // ─── STEAM & CONTENT ──────────────────────────────────
  { category: 'Steam Level', keywords: [
    'Clean / No Steam', 'Sweet', 'Closed Door', 'Fade to Black',
    'Mild Steam', 'Moderate Steam', 'Open Door', 'Steamy',
    'Very Steamy', 'Explicit', 'Erotica',
  ]},

  { category: 'Content Warnings', keywords: [
    'Abuse', 'Past Abuse', 'Domestic Violence', 'Sexual Assault',
    'Child Abuse (Referenced)', 'Bullying', 'Graphic Violence',
    'Gore', 'Torture', 'War Violence', 'Gun Violence',
    'Self-Harm', 'Suicide / Suicidal Ideation', 'Eating Disorders',
    'Addiction', 'Drug Use', 'Alcoholism',
    'Death of a Loved One', 'Parental Death', 'Child Death',
    'Animal Death', 'Miscarriage / Pregnancy Loss',
    'Dubious Consent', 'Non-Consent (Referenced)',
    'Cheating / Infidelity', 'Gaslighting', 'Stalking',
    'Kidnapping', 'Captivity', 'Human Trafficking',
    'Mental Health Issues', 'PTSD', 'Anxiety', 'Depression',
    'Panic Attacks', 'Ableism', 'Racism', 'Homophobia',
    'Religious Trauma', 'Cult', 'Body Horror',
    'Blood / Medical Procedures', 'Claustrophobia', 'Drowning',
    'Fire', 'Natural Disasters',
    'No HEA', 'Cliffhanger Ending',
  ]},

  // ─── KINKS (for romance/erotica) ─────────────────────
  { category: 'Kinks & Spice', keywords: [
    'Fem-Dom', 'Male-Dom', 'Switch / Role Reversal',
    'Bondage', 'Spanking', 'Praise Kink', 'Degradation',
    'Daddy Kink', 'Breeding Kink', 'Size Kink',
    'Consensual Non-Consent', 'Voyeurism', 'Exhibitionism',
    'Menage / Threesome', 'MMF', 'MFM', 'FFM', 'MMM',
    'Poly / Polyamory', 'Open Relationship',
    'Reverse Harem / Why Choose',
    'Omegaverse', 'Alpha / Omega', 'Monstrous Anatomy',
    'Tentacles', 'Biting / Marking', 'Knotting',
  ]},

  // ─── STORY STRUCTURE ──────────────────────────────────
  { category: 'Story Structure', keywords: [
    'Standalone', 'First in Series', 'Series', 'Duology', 'Trilogy',
    'Companion Novel', 'Spin-Off', 'Prequel', 'Sequel',
    'Interconnected Standalones',
    'HEA (Happily Ever After)', 'HFN (Happy For Now)',
    'No HEA', 'Tragic Ending', 'Open Ending', 'Cliffhanger',
    'Dual Timeline', 'Non-Linear', 'Flashbacks',
    'Epistolary (Letters/Emails)', 'Diary / Journal Format',
    'Multiple Timelines', 'Parallel Narratives',
    'Unreliable Narrator', 'Plot Twist', 'Slow Build',
  ]},
];

// Build a flat searchable index for smart search
let _flatIndex = null;
export function getFlatKeywords() {
  if (_flatIndex) return _flatIndex;
  _flatIndex = [];
  for (const section of FICTION_KEYWORDS) {
    for (const kw of section.keywords) {
      _flatIndex.push({ keyword: kw, category: section.category });
    }
  }
  return _flatIndex;
}

// Smart search: returns matching keywords sorted by relevance
export function searchKeywords(query) {
  if (!query || !query.trim()) return [];
  const q = query.toLowerCase().trim();
  const all = getFlatKeywords();
  const startsWithMatches = [];
  const containsMatches = [];

  for (const item of all) {
    const lower = item.keyword.toLowerCase();
    if (lower.startsWith(q)) {
      startsWithMatches.push(item);
    } else if (lower.includes(q)) {
      containsMatches.push(item);
    }
  }
  // Deduplicate (same keyword may appear in multiple categories)
  const seen = new Set();
  const results = [];
  for (const item of [...startsWithMatches, ...containsMatches]) {
    const key = item.keyword;
    if (!seen.has(key)) {
      seen.add(key);
      results.push(item);
    }
  }
  return results.slice(0, 20);
}

// Get all unique categories
export function getCategories() {
  return FICTION_KEYWORDS.map(s => s.category);
}

// Get keywords by category
export function getKeywordsByCategory(category) {
  const section = FICTION_KEYWORDS.find(s => s.category === category);
  return section ? section.keywords : [];
}
